module.exports = __webpack_public_path__ + "static/media/world-image.cd4c4d09.png";